export default "__VITE_ASSET__63a65939__"